import { useQuery } from '@apollo/client'
import { SITES_AUTOCOMPLETE_LIMIT } from 'features/Sites/constants'
import { GET_SITES_AUTOCOMPLETE } from 'features/Sites/queries-legacy'
import { GTSiteAutocomplete } from 'gql/types.generated'

interface IUseSiteAutocompleteOptions {
  skip?: boolean
}

export const useSiteAutocomplete = (siteId: string, { skip }: IUseSiteAutocompleteOptions = {}): GTSiteAutocomplete => {
  const { data } = useQuery<{ sitesAutocomplete: GTSiteAutocomplete[] }>(GET_SITES_AUTOCOMPLETE, {
    skip,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      limit: SITES_AUTOCOMPLETE_LIMIT
    }
  })

  return data?.sitesAutocomplete?.find((site) => site.id === siteId) || { id: siteId, name: '', companyID: '' }
}
